import { FC } from 'react';

import {
    Email as EmailIcon,
    LocationOn as LocationOnIcon,
    Person as PersonIcon,
    Smartphone as SmartphoneIcon,
} from '@mui/icons-material';
import { Grid } from '@mui/material';
import { renameKeys } from '@npi/buddy-utils';

import ContactItem from './ContactItem';

export type ContactInformation = {
    firstName: string;
    lastName: string;
    email: string;
    mobilePhoneNumber: string;
    country: string;
    isBillingContact: boolean;
};

interface ContactProps {
    contactInformation?: ContactInformation;
    isMerchant?: boolean;
    activeStep?: string;
}

const Contact: FC<ContactProps> = ({ contactInformation, isMerchant, activeStep }) => {
    const contactData = isMerchant ? contactInformation : renameKeys(contactInformation);
    const dataTestId = `${activeStep}-contact`;

    return (
        <Grid data-testid={dataTestId} sx={{ borderTop: '0.5px solid #DADADA' }}>
            <ContactItem
                dataTestId={`${dataTestId}-name`}
                icon={<PersonIcon sx={{ color: '#575757' }} />}
                label="Name"
                value={`${contactData?.firstName || '-'} ${contactData?.lastName || '-'}`}
            />
            <ContactItem
                dataTestId={`${dataTestId}-email`}
                icon={<EmailIcon sx={{ color: '#575757' }} />}
                label="Email"
                value={contactData?.email || '-'}
            />
            <ContactItem
                dataTestId={`${dataTestId}-number`}
                icon={<SmartphoneIcon sx={{ color: '#575757' }} />}
                label="Phone"
                value={contactData?.mobilePhoneNumber || '-'}
            />
            <ContactItem
                dataTestId={`${dataTestId}-location`}
                icon={<LocationOnIcon sx={{ color: '#575757' }} />}
                label="Address"
                value={contactData?.country || '-'}
            />
        </Grid>
    );
};

export default Contact;
